/**
 * The project's formatting settings for one file (#987): read by
 * project-config.ts on the main thread, applied by format-document.ts in the
 * worker — plain data, and free of the config parsers so the worker stays small.
 */
export interface FormatConfig {
  /** Prettier options from `.prettierrc` (+ matching overrides), or null when the project has none. */
  prettier: Record<string, unknown> | null
  /** Options `.editorconfig` gives this file, in Prettier's terms. */
  editorconfig: { useTabs?: boolean; tabWidth?: number; printWidth?: number; endOfLine?: 'lf' | 'crlf' | 'cr' } | null
  /** Ruff settings (`line-length`, `indent-width`, `format`), or null when the project has none. */
  ruff: Record<string, unknown> | null
  /** A config the browser can't read (a JS Prettier config) found nearer than any it can. */
  unreadable: string | null
}

export const EMPTY_FORMAT_CONFIG: FormatConfig = { prettier: null, editorconfig: null, ruff: null, unreadable: null }
